// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"12":"fd98942e","110":"633ade9e","115":"054632b5","354":"4480c904","647":"9774ebeb"}[chunkId] + ".js";
};